/* eslint-disable max-len */
import * as React from 'react';

const SupportIcon = (props) => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      clipPath="url(#clip0_4559_17178)"
    >
      <path d="M6.499 1.681a6.5 6.5 0 0 0-4.82 4.82M14.319 6.5A6.5 6.5 0 0 0 9.5 1.681M9.5 14.319A6.5 6.5 0 0 0 14.319 9.5M1.68 9.5a6.5 6.5 0 0 0 4.819 4.819M6.5 4.837V.5h3v4.337M11.16 6.5h4.338v3H11.16M9.5 11.162V15.5h-3v-4.338" />
      <path d="M4.838 9.5H.5v-3h4.338" />
      <path d="M8 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" />
    </g>
    <defs>
      <clipPath id="clip0_4559_17178">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SupportIcon;